const _bindUIActions = function _bindUIActions() {
  $('#signup-form').submit(function submitSignupForm(e) {
    e.preventDefault();

    const $form = $(this);
    const email = $form.find('input[name="email"]').val();
    const origin = $form.find('input[name="Origin"]').val();
    const url = $form.attr('action');
    $('#sendy-tf').fadeOut();
    $('#sendy-submit').fadeOut();
    $('#sendy-status').text('Loading...');
    $.post(url, {
      email,
      Origin: origin,
      list: 'C0kimYT2XPMbzC892KJs8t2A',
    }, (data) => {
      if (data) {
        if (data === 'Some fields are missing.') {
          $('#sendy-status').text('Please fill in your email.');
          $('#sendy-status').css('color', 'red');
          $('#sendy-tf').fadeIn();
          $('#sendy-submit').fadeIn();
        } else if (data === 'Invalid email address.') {
          $('#sendy-status').text('Your email address is invalid.');
          $('#sendy-status').css('color', 'red');
          $('#sendy-tf').fadeIn();
          $('#sendy-submit').fadeIn();
        } else if (data === 'Invalid list ID.') {
          $('#sendy-status').text('Your list ID is invalid.');
          $('#sendy-status').css('color', 'red');
        } else if (data === 'Already subscribed.') {
          $('#sendy-status').text('You\'re already subscribed!');
        } else {
          $('#sendy-status').text('Thank you, you\'re subscribed!');
        }
      } else {
        alert('Sorry, unable to subscribe. Please try again later!');
      }
    });
  });
};

const VSFooter = {
  init() {
    _bindUIActions();
  },
};

export default VSFooter;
